import {AggregationFunction, CurrencyMode, IStatisticModel, PeriodType} from '../model/IStats';

export const MONTH_OPTIONS = [
    {value: 1, label: 'January'},
    {value: 2, label: 'February'},
    {value: 3, label: 'March'},
    {value: 4, label: 'April'},
    {value: 5, label: 'May'},
    {value: 6, label: 'June'},
    {value: 7, label: 'July'},
    {value: 8, label: 'August'},
    {value: 9, label: 'September'},
    {value: 10, label: 'October'},
    {value: 11, label: 'November'},
    {value: 12, label: 'December'},
];

export function periodTypeLabel(periodType: PeriodType): string {
    if (periodType === 'month') {
        return 'Month';
    }
    if (periodType === 'last_n_months') {
        return 'Last N months';
    }
    return 'Date range';
}

export function currencyModeLabel(currencyMode: CurrencyMode): string {
    if (currencyMode === 'multi') {
        return 'BYN / EUR / USD';
    }
    if (currencyMode === 'fixed') {
        return 'Fixed currency';
    }
    return 'Ask on run';
}

export function aggregationLabel(model: Pick<IStatisticModel, 'group_by_category' | 'group_by_month' | 'aggregation_function'>): string {
    const functionLabel = model.aggregation_function === 'avg' ? 'Average' : 'Sum';
    const parts = [];
    if (model.group_by_category) {
        parts.push('category');
    }
    if (model.group_by_month) {
        parts.push('month');
    }
    if (!parts.length) {
        return `${functionLabel} total`;
    }
    return `${functionLabel} by ${parts.join(', ')}`;
}

export function pickByIds<T extends {id: number}>(items: T[] | undefined, ids: number[]): T[] {
    if (!items || !ids.length) {
        return [];
    }
    const idSet = new Set(ids);
    return items.filter((item) => idSet.has(item.id));
}

export const PERIOD_TYPE_OPTIONS: {value: PeriodType, label: string}[] = [
    {value: 'month', label: 'Particular month'},
    {value: 'last_n_months', label: 'Last N months'},
    {value: 'date_range', label: 'Date range'},
];

export const CURRENCY_MODE_OPTIONS: {value: CurrencyMode, label: string}[] = [
    {value: 'multi', label: 'BYN / EUR / USD'},
    {value: 'fixed', label: 'Fixed currency'},
    {value: 'parameterized', label: 'Ask on run'},
];

export const AGGREGATION_FUNCTION_OPTIONS: {value: AggregationFunction, label: string}[] = [
    {value: 'sum', label: 'Sum'},
    {value: 'avg', label: 'Average (across months)'},
];
